module.exports = __webpack_public_path__ + "static/media/baner_practice_training.85b6a098.jpg";